import { createRoot } from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { HelmetProvider } from 'react-helmet-async';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { CircularProgress } from '@mui/material';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'

import ErrorHandler from '~/components/ErrorHandler';

import { persistor, store } from '~/store';

import reportWebVitals from './reportWebVitals';
import Root from './Root';

window.store = store;

const { APP_ENV = '' } = process.env;

const container = document.getElementById('root');

if (container) {
  const root = createRoot(container);

  root.render(
    <BrowserRouter>
      <Provider store={store}>
        <PersistGate loading={<CircularProgress size="huge" />} persistor={persistor}>
          <ErrorBoundary FallbackComponent={ErrorHandler}>
            <HelmetProvider>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Root />
              </LocalizationProvider>
            </HelmetProvider>
          </ErrorBoundary>
        </PersistGate>
      </Provider>
    </BrowserRouter>,
  );
}

/* c8 ignore next 3 */
if (['local', 'development'].includes(APP_ENV)) {
  reportWebVitals(console.log);
}
